import type { ComponentType } from "react";

import ExecBridgeFlow from "./views/ExecBridgeFlow";
import type { XFactorViewDefinition } from "../../Types/XFactorViewsRendering";

/**
 * View registry — the EB counterpart to xfactor's
 * `src/lib/views-rendering/registry.ts`.
 *
 * Views are plug-ins: adding one means adding a component and an entry here.
 * The host renders whichever is selected and knows nothing else about them.
 *
 * xfactor registers six. Five are Public Data or KPI Metrics *fragments* that
 * ExecBridge Flow already contains (its bubble matrix, its R-O chart, its
 * executive summary), and the KPI ones have no reachable data source from EB —
 * so the flow is the only entry worth registering here today.
 */
export interface XFactorRegisteredView extends XFactorViewDefinition {
  component: ComponentType;
}

export const VIEW_REGISTRY: XFactorRegisteredView[] = [
  {
    id: "execbridge-flow",
    name: "ExecBridge Flow",
    description:
      "End-to-end stitched experience: account portfolio (list / bubble / RO), account synopsis, and every briefing artifact — Situation Card, Executive Brief, Exec Profiles, Cards, Section and Full Briefing modals.",
    component: ExecBridgeFlow,
  },
];

export const DEFAULT_VIEW_ID = VIEW_REGISTRY[0].id;
